export default __webpack_public_path__ + "static/media/worker6.e01d1259.jpg";